<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col v-if="openPicks.length <= 0" cols="12" sm="12">
            <v-card class="elevation-0">
                <v-alert height="60vh" class=" d-flex justify-center" elevation="0">Keine Offene Picks zur Auswahl.</v-alert>
            </v-card>
        </v-col>
        <v-col v-for="(openPick, indx) in openPicks" :key="indx" cols="12" md="6" sm="12">
          <v-card class="elevation-3" tile>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="headline">{{openPick.pixi_id}}</v-list-item-title>
                <v-list-item-subtitle>Erstellt von {{openPick.created_from}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
            <v-list>
              <v-list-item>
                <v-icon>mdi-package-variant</v-icon>
                <v-list-item-title class="ml-3">Box:</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{openPick.box_from}}-{{openPick.box_to}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-icon>mdi-calendar-clock</v-icon>
                <v-list-item-title class="ml-3">Erstellt am:</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{formatDate(openPick.created_at)}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-icon>mdi-calendar-clock</v-icon>
                <v-list-item-title class="ml-3">Ablaufdatum:</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{formatDate(openPick.expires_at)}}</v-list-item-subtitle>
              </v-list-item>
            </v-list>
            <v-divider />
            <v-card-actions>
              <v-btn text color="#323232">Details</v-btn>
              <v-spacer />
              <v-btn @click.stop="selectOpenPick(openPick.id, openPick.pixi_id)" text color="#ff9117">Picken</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog.open" max-width="400">
      <v-card>
        <v-card-title>{{dialog.title}}</v-card-title>
        <v-card-text>{{dialog.text}}</v-card-text>
        <v-card-actions>
          <v-btn color="#191919" text @click="dialog.open = false">Abbrechen</v-btn>
          <v-spacer />
          <v-btn color="#faa619" text @click="dialog.action()">Zustimmen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ selectedPickStatusText }}
      <v-btn color="white" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import picklistService from "../services/picklistService";
import datetimeFormatter from "../helpers/datetimeFormatter";
import { mapState } from "vuex";

export default {
  name: "OpenPicksList",
  data() {
    return {
      dialog: {
        open: false,
        title: "",
        text: ""
      },
      selectedOpenPick: {
        id: "",
        pixiId: "",
      },
      snackbar: false,
      snackbarColor: "white",
      selectedPickStatusText: ""
    };
  },
  computed: mapState({
    openPicks: state => state.picklists.openPicklist,
    currentOpenPick: state => state.currentPick.open
  }),
  methods: {
    pick() {
      this.dialog.open = false;
      picklistService
        .startPick(this.selectedOpenPick.pixiId)
        .then(startedPick => {
          this.snackbar = true;
          this.selectedPickStatusText = "Erfolgreich gepickt";
          this.snackbarColor = "#faa619";
          const that = this;
          console.log(startedPick);

          picklistService.picklist()
          .then(() => picklistService.picklistDetails(startedPick.id))
          .then(pickDetail => {
            that.$store.dispatch("setCurrentPick", {
              items: [...pickDetail.items],
              open: [...pickDetail.items],
              done: [],
              pick: pickDetail.items[0],
              id: startedPick.id,
              pixi_id: that.selectedOpenPick.pixiId,
            });
            that.$router.push("/pick");
          })
          .catch(e => {
            console.log(e);
          });
        })
        .catch(() => {
          that.snackbar = true;
          that.selectedPickStatusText = "Konnte nicht gepickt werden";
          that.snackbarColor = "red";
        });
    },

    selectOpenPick(id, pixiId) {
      console.log("selectOpenPick id: " + id);
      this.dialog.open = true;
      this.dialog.title = `Pick für ${pixiId} durchführen?`;
      this.dialog.text = "Drücken Sie auf Zustimmen um einen Pick durchzuführen.";
      this.dialog.action = this.pick;
      this.selectedOpenPick.id = id;
      this.selectedOpenPick.pixiId = pixiId;
    },

    formatDate(value) {
      return datetimeFormatter.formatIntoDateTime(value);
    }
  }
};
</script>